export default __webpack_public_path__ + "static/media/DASHPORT_color_horizontal.211807cc.png";